import React, { useState } from "react";
import API_BASE_URL from "../../config";
import "../SOA/SendSOAModal.css";

function SendACAConsentModal({ record, recordType, onClose }) {
  const [sendMethod, setSendMethod] = useState("email");
  const [customDestination, setCustomDestination] = useState("");

  const handleSend = async () => {
    const token = localStorage.getItem("token");

    let destination = "";

    if (sendMethod === "email") destination = record.email;
    if (sendMethod === "text") destination = record.phone;
    if (sendMethod === "custom") destination = customDestination;

    const payload = {
      lead_id: recordType === "lead" ? record.id : null,
      client_id: recordType === "client" ? record.id : null,
      send_method: sendMethod,
      destination
    };

    try {
      const res = await fetch(`${API_BASE_URL}/api/aca-consent/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("ACA Consent send error:", data);
        alert(data.message || "Failed to send ACA Consent.");
        return;
      }

      const signing_link = data.signing_link;

      const mergeData = {
        aca_consent_link: signing_link
      };

      console.log("Generated ACA Consent link:", signing_link);
      console.log("Merge data available:", mergeData);

      alert("ACA Consent sent successfully.");
      onClose();
    } catch (err) {
      console.error("ACA Consent send error:", err);
      alert("Error sending ACA Consent.");
    }
  };

  return (
    <div className="soa-modal-backdrop">
      <div className="soa-modal">
        <div className="soa-modal-header">
          <div className="soa-modal-title">Send ACA Consent</div>

          <button
            className="soa-modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="soa-send-box">
          <p className="soa-instruction">
            Please select where you would like to send the ACA Consent form:
          </p>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "email"}
              onChange={() => setSendMethod("email")}
            />
            <div>
              <strong>Email:</strong> {record.email || "No email available"}
            </div>
          </div>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "text"}
              onChange={() => setSendMethod("text")}
            />
            <div>
              <strong>Text:</strong> {record.phone || "No phone available"}
            </div>
          </div>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "custom"}
              onChange={() => setSendMethod("custom")}
            />
            <div>New Email Or Mobile Number</div>
          </div>

          {sendMethod === "custom" && (
            <input
              className="soa-destination-input"
              type="text"
              placeholder="Enter email or mobile number"
              value={customDestination}
              onChange={(e) => setCustomDestination(e.target.value)}
            />
          )}
        </div>

        <div className="soa-modal-footer">
          <button
            className="soa-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="soa-send-btn"
            onClick={handleSend}
          >
            Send ACA Consent →
          </button>
        </div>
      </div>
    </div>
  );
}

export default SendACAConsentModal;